import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Badge, Button, Card, Grid, InputCheckbox, Text, Icon } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { usePostHog } from "posthog-js/react";
import styled from "styled-components";
import lists from "~/lib/lists";
import set from "lodash.set";
import { useDrag, useDrop } from "react-dnd";
import insightsActionCreators from "~/store/insights/actions";
import { useDispatch, useSelector } from "react-redux";
import insightsSelectors from "~/store/insights/selectors";
const DragHandle = styled.div`
  cursor: move;
`;
const InsightsConfigureViewDropdownItem = _ref => {
  let {
    item,
    moveItem,
    findItem,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const view = useSelector(insightsSelectors.getView);
  const sizeIndex = item.allowedSizes.findIndex(size => size === item.size);
  const originalIndex = findItem(item.type).index;
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const [{
    isDragging
  }, drag, preview] = useDrag(() => ({
    type: "insightsWidget",
    item: {
      id: item.type,
      originalIndex
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    }),
    end: (dragItem, monitor) => {
      if (!monitor.didDrop()) {
        moveItem(dragItem.id, dragItem.originalIndex);
      }
    }
  }), [item.type, originalIndex, moveItem]);
  const [, drop] = useDrop(() => ({
    accept: "insightsWidget",
    hover(dragItem) {
      if (dragItem.id !== item.type) {
        const {
          index: overIndex
        } = findItem(item.type);
        moveItem(dragItem.id, overIndex);
      }
    }
  }), [findItem, moveItem]);
  const handleUpdateView = (param, value) => {
    posthog.capture(`Member Insights – Update View`, {
      param,
      value
    });
    dispatch(insightsActionCreators.updateViewSucceeded(set(view, param, value)));
  };
  const handleIncreaseSize = () => {
    if (sizeIndex < item.allowedSizes.length && view) {
      handleUpdateView("", view.map(c => {
        if (c.type === item.type) {
          c.size = item.allowedSizes[sizeIndex + 1];
        }
        return c;
      }));
    }
  };
  const handleDecreaseSize = () => {
    if (sizeIndex > 0 && view) {
      handleUpdateView("", view.map(c => {
        if (c.type === item.type) {
          c.size = item.allowedSizes[sizeIndex - 1];
        }
        return c;
      }));
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: node => preview(drop(node)),
    style: {
      opacity: isDragging ? 0 : 1
    }
  }, /*#__PURE__*/React.createElement(Card, _extends({
    color: "background",
    s: {
      p: 3
    },
    border: true
  }, rest), /*#__PURE__*/React.createElement(Grid, {
    cols: 4,
    template: "2rem 2rem 1fr auto 2rem auto 2rem"
  }, /*#__PURE__*/React.createElement(DragHandle, {
    ref: drag,
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("TopicTargetCard.dragToReorder")
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "drag"
  })), /*#__PURE__*/React.createElement(InputCheckbox, {
    s: {
      mt: -2
    },
    value: item.enabled,
    onChange: value => handleUpdateView(`[${originalIndex}].enabled`, value)
  }), /*#__PURE__*/React.createElement(Text, {
    fontSize: 4
  }, lists.insights.widgetTypes.names[item.type]), /*#__PURE__*/React.createElement(Badge, {
    color: "translucentPrimary",
    s: {
      py: 0.5,
      mr: 2
    }
  }, lists.insights.widgetCategories.fromWidgetTypes[item.type]), /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Decrease widget size",
    color: "translucent",
    onClick: handleDecreaseSize,
    disabled: sizeIndex === 0,
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      mr: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 3,
    src: "chevron",
    rotate: -90
  })), item.size || "-", /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Increase widget size",
    color: "translucent",
    onClick: handleIncreaseSize,
    disabled: sizeIndex === item.allowedSizes.length - 1,
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      ml: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 3,
    src: "chevron",
    rotate: 90
  })))));
};
export default InsightsConfigureViewDropdownItem;